import gql from 'graphql-tag';
import { query } from 'services/graphql';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const surfaceNodesQuery = gql`
  query surfaceNodes($input: SurfaceNodesInput) {
    surfaceNodes(input: $input) {
      error
      nodes {
        ... on SurfaceNode {
          id
          risk
        }
        ...surfaceNodeUnionDetails

        ... on SubSurfaceNode {
          id
          name
          description
          ratingComment
          rating
        }
      }
      meta {
        totalCount
        count
        totalPages
        offset {
          page
          perPage
        }
      }
    }
  }
  ${surfaceUnionFragment}
`;

// console.warn('AAAA XXX ', surfaceUnionFragment);
export default query(surfaceNodesQuery);
